// Shared prompt-role vocabulary (mirrors backend PROMPT_ROLES). Used by the
// Prompts library and Brands admin pages.
export const ROLES = ["classifier", "generator", "critic"] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<string, string> = {
  classifier: "Классификатор",
  generator: "Генератор",
  critic: "Критик",
};
